export default __webpack_public_path__ + "static/media/group-7028.49f4111b.svg";